import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'
import rehypeRaw from 'rehype-raw'

export default class Markdown extends React.Component {
  getLinkTarget = ({ href, children }) => {
    let target = 'blank'

    if (href.slice(0, 7).toLowerCase() === 'mailto:') {
      target = 'blank'
    }

    const newChildren = children.map((child) => {
      if (typeof child === 'string') {
        if (child.includes('>>>')) {
          target = ''
          return child.replace('>>>', '')
        }
        return child
      }
      return child
    })

    const useNativeLink = href.slice(0,5).includes('http');

    return { target, children: newChildren, useNativeLink }
  }
  render() {
    const { source, className = '', style, id } = this.props
    return (
      <ReactMarkdown
        children={source}
        className={className}
        components={{
          root: ({ children }) => (
            <div className={className} id={id} style={style}>
              {children}
            </div>
          ),
          link: (props) => {
            const { target, children, useNativeLink } = this.getLinkTarget({
              children: props.children,
              href: props.href,
            })
            return (
              useNativeLink ?
              <a href={props.href} target={target}>
                {children}
              </a>
              :
              <Link to={props.href} target={target}>
                {children}
              </Link>
            )
          },
          code: (props) => <pre>{props.value}</pre>,
        }}
        rehypePlugins={[rehypeRaw]}
      />
    )
  }
}
